import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children, isAuthenticated }) => {
  const location = useLocation();

  if (!isAuthenticated) {
    const fullPath = location.pathname + location.search;

    const isLmsPath = location.pathname.startsWith('/lms');

    if (isLmsPath) {
      sessionStorage.setItem('redirectAfterLogin', fullPath);
    }
    
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
